"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../core/button"));
var _alert = _interopRequireDefault(require("../../../core/alert"));
var _mapDays = _interopRequireDefault(require("./map-days"));
var _byCompetition = _interopRequireDefault(require("./by-competition"));
var _byDivision = _interopRequireDefault(require("./by-division"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "info"
}, /*#__PURE__*/_react.default.createElement("p", null, "Once the day mappings exist, races and results will be automatically mapped during batch processing. This may take 24hrs."), /*#__PURE__*/_react.default.createElement("p", null, "Warning: Do not map finals/semis. Only one phase should be mapped to avoid double counting entries. Finals and semis should be ignored."));
var _ref2 = /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "info"
}, /*#__PURE__*/_react.default.createElement("p", null, "Non-ranked paddlers who entered by post before being added to the ranking lists are matched on name where possible, but may appear as a no-show and then also appear as entering on the Day."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, "Div 4 results are only partially loaded to the ranking database - only paddlers being promoted are loaded. Therefore, any div 4s who are not promoted will show as a \"no-show\" and the percentage entering in advance will be skewed!")), /*#__PURE__*/_react.default.createElement("p", null, "Counts are based on a bib per event (ie bib 15 competing Saturday and Sunday counts as 2 entries)"), /*#__PURE__*/_react.default.createElement("p", null, "The competitions summary only includes events where there is at least one result. The Division Summary includes all events for any competition with results."));
class EntrySource extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      isMapping: false
    });
    _defineProperty(this, "_mapRankingDays", () => {
      this.setState({
        isMapping: !this.state.isMapping
      });
    });
  }
  render() {
    const outstandingMaps = this.props.rdbDayMap.some(d => !d.competitionDayID && !d.isExcluded);
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._mapRankingDays,
      type: outstandingMaps ? 'danger' : undefined
    }, outstandingMaps ? 'New Mappings Required' : this.state.isMapping ? 'Hide Mappings' : 'Show Mappings')), !this.state.isMapping ? null : /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-header"
    }, /*#__PURE__*/_react.default.createElement("h4", null, "Map Ranking Database Days to CanoeSlalomEntries ", this.props.match.params.yearID)), /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, _ref, /*#__PURE__*/_react.default.createElement(_mapDays.default, {
      rdbDayMap: this.props.rdbDayMap,
      yearID: this.props.match.params.yearID
    }))), _ref2, /*#__PURE__*/_react.default.createElement(_byDivision.default, {
      statsByYear: this.props.statsByYear
    }), /*#__PURE__*/_react.default.createElement(_byCompetition.default, {
      statsByYear: this.props.statsByYear
    }));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref3 = {
  id: true,
  entrySource: true
};
var _ref4 = {
  id: true,
  rdbCompetitionDayID: true,
  rdbCompetitionName: true,
  rdbDayDate: true,
  competitionDayID: true,
  competitionID: true,
  isExcluded: true,
  competition: {
    shortName: true
  },
  competitionDay: {
    dayDate: true
  }
};
var _default = exports.default = (0, _reactBicycle.connect)(EntrySource, props => ({
  ["statsByYear(yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref3,
  ["rdbDayMap(yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref4
}));